const apiRoute = (route: string) => window.env.REACT_APP_ADMIN_URL + route

export {
  apiRoute
}
